import { ref, type Ref } from 'vue';
import type { FilterModifier, TableState } from '../internal';

type ValuesInMap<T_> = T_ extends Map<unknown, infer I> ? I : never;

export function useTableFilter<T extends Record<string, unknown>>(params: {
  triggerChange: () => void;
}) {
  const filterModifier = ref<FilterModifier>('and');
  const filterInfo = ref(new Map()) as Ref<Required<TableState<T>>['filterValues']>;

  function onFilter(columnId: string, newValue: ValuesInMap<TableState<T>['filterValues']>) {
    if (newValue.length > 0) {
      filterInfo.value.set(columnId, newValue);
    } else {
      filterInfo.value.delete(columnId);
    }
    params.triggerChange();
  }

  return { filterModifier, filterInfo, onFilter };
}
